<template>
  <div>

    <a-card :bordered="true">
      <a-row>
        <a-col :sm="8" :xs="24">
          <head-info title="报名人数" :content="totalNum + '个'" :bordered="true" />
        </a-col>
        <a-col :sm="8" :xs="24">
          <head-info title="开始时间" :content="startTime" :bordered="true" />
        </a-col>
        <a-col :sm="8" :xs="24">
          <head-info title="结束时间" :content="endTime" :bordered="false" />
        </a-col>
      </a-row>
    </a-card>

    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row>
            <a-col :sm="4" :xs="24">
              <a-form-item>
                <a-input placeholder="请输入身份证号" v-model="queryParam.idCard" />
              </a-form-item>
            </a-col>
            <a-col :sm="4" :xs="24">
              <a-form-item>
                <a-select
                  placeholder="请选择函授站"
                  v-model="queryParam.correspondenceStation"
                  :options="optionList"
                  allowClear
                >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-button @click="() => {this.queryData()}" type="primary">查询</a-button>
              <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-button icon="import"><a href="/edu/adult/admin/downloadTemplate">下载模板</a>
              </a-button>
              <a-button icon="import" style="margin-left: 5px">
                <a href="/edu/adult/admin/export">导出</a>
              </a-button>
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-upload
                name="file"
                :showUploadList="false"
                :multiple="false"
                :customRequest="uploadFuncs"
                @change="handleImportExcel">
                <a-button type="primary" icon="import">导入</a-button>
              </a-upload>
              <a-button icon="import" style="margin-left: 5px">
                <a href="/edu/adult/admin/getStationCount">各站人数</a>
              </a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col :sm="4" :xs="24">
              <a-range-picker
                @change="onChange"
                format="YYYY-MM-DD"
              />
            </a-col>
            <a-col :sm="4" :xs="12">
              <a-button @click="() => {this.changeTimeLimit()}" type="primary">确定</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        :columns="columns"
        :dataSource="tableData"
        :loading="loading"
        :pagination="pagination"
        :rowKey="record => record.id"
        @change="handleTableChange"
        bordered
      >
        <span slot="volunteer" slot-scope="text, record">
          <div v-if="text==='1'">第一志愿</div>
          <div v-else-if="text==='2'">第二志愿</div>
        </span>
        <span slot="remark" slot-scope="text, record" style="width: 30px;">
            <a-tooltip placement="topLeft">
             <template slot="title">
              <span>{{ text }}</span>
            </template>
            {{ text | ellipsis(length) }}
            </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
        <a-button
          icon="edit"
          type="primary"
          style="margin-right: 10px"
          @click="$refs.stationEdit.edit(record.id)"
        >编辑
        </a-button>
        <a-popconfirm title="是否删除" @confirm="deleteItem(record.id)" okText="是" cancelText="否">
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <a-button
            icon="delete"
            type="primary"
          >删除
          </a-button>
        </a-popconfirm>
        </span>
      </a-table>
    </a-card>
    <admin-station-edit ref="stationEdit" @ok="init"></admin-station-edit>
  </div>
</template>

<script>
import moment from 'moment'
import HeadInfo from '@/components/tools/HeadInfo'
import { applyList, deleteApply, exportExcel, adminUploadFunc, changeTime } from '@api/adult/openRecruit.js'
import adminStationEdit from '@/views/modules/adult/modules/adminStationEdit'
import { adultApplyOption } from '@/api/adult/customChannel'

export default {
  name: 'OpenRecruit1',
  components: {
    HeadInfo,
    adminStationEdit
  },
  data () {
    return {
      length: 10,
      loading: false,
      columns: [
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '性别',
          dataIndex: 'gender'
        },
        {
          title: '身份证',
          dataIndex: 'idCard'
        },
        {
          title: '层次',
          dataIndex: 'level'
        },
        {
          title: '报考专业',
          dataIndex: 'profession'
        },
        {
          title: '考生联系方式',
          dataIndex: 'phoneNumber'
        },
        {
          title: '所在地',
          dataIndex: 'studentCity'
        },
        {
          title: '报名时间',
          dataIndex: 'applyTime',
          width: 147
        },
        {
          title: '学习中心名称',
          dataIndex: 'correspondenceStation'
        },
        {
          title: '志愿',
          dataIndex: 'volunteer',
          scopedSlots: { customRender: 'volunteer' }
        },
        {
          title: '其它',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          width: 100
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tableData: [],
      optionList: [],
      queryParam: {
        idCard: ''
      },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        showSizeChanger: true,
        showTotal: total => '共' + total + '条'
      },
      pages: {
        size: 10,
        current: 1
      },
      changeTime: {
        startTime: '',
        endTime: ''
      },
      startTime: '',
      endTime: '',
      totalNum: ''
    }
  },
  methods: {
    // 获取函授站信息
    getOptionList () {
      adultApplyOption().then(res => {
        this.optionList = res.data
        this.optionList.push({ label: '直报', value: '110' })
      })
    },
    // 自定义上传方法
    uploadFuncs (file) {
      this.confirmLoading = true
      const formData = new FormData()
      formData.append('file', file.file)
      adminUploadFunc(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success('上传成功')
          this.init()
        } else {
          this.$message.warning(res.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    // 文件上传状态
    handleImportExcel (info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name} 上传成功.`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    init () {
      this.loading = true
      applyList({
        ...this.pages,
        ...this.queryParam
      }).then(res => {
        this.tableData = res.data.listUser
        this.pagination.total = res.data.total2
        this.startTime = res.data.startTime
        this.endTime = res.data.endTime
        this.totalNum = res.data.total
        this.loading = false
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = pagination
      this.pages.size = pagination.pageSize
      this.pages.current = pagination.current
      this.init()
    },
    deleteItem (id) {
      console.log('id', id)
      deleteApply(id).then(res => {
        this.init()
      })
    },
    adminExportExcel () {
      exportExcel()
    },
    queryData () {
      this.pages.current = 1
      this.init()
    },
    handleOk () {
      this.init()
    },
    moment,
    onChange (date, dateString) {
      this.changeTime.startTime = dateString[0]
      this.changeTime.endTime = dateString[1]
    },
    // eslint-disable-next-line vue/no-dupe-keys
    changeTimeLimit () {
      changeTime(this.changeTime).then(res => {
        this.$message.success(res.msg)
        this.init()
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }
  },
  created () {
    this.init()
    this.getOptionList()
  }
}
</script>

<style scoped>

</style>
